<template>
  <div>
    <nav-default></nav-default>
    <b-container>
      <b-row class="dashboard-container">
        <b-col lg="3" md="0" sm="0" cols="0" >
          <md-button class="md-primary md-raised add-listing-btn blue-button" style="visibility:hidden">Add Listing</md-button>
          <dashboard-drawer></dashboard-drawer>
        </b-col>

        <b-col lg="6" md="12" sm="12" cols="12" class="m-0 p-0">
            <div @click="reloadRequests" class="refresh-dash-container">
              <md-button class="md-icon-button md-raised" :disabled="reloadingDasboardItems">
                <div v-if="reloadingDasboardItems" class="loader-rolling-local_white" style="color:white"></div>
                <md-icon v-else>cached</md-icon>
              </md-button>
            </div>

            <!-- <md-toolbar class="md-dense md-primary mo-toolbar-tab"  style="width: 100%;max-width:100vw" >
              <h3 class="md-title">Requests</h3>
            </md-toolbar>
             -->

            <md-tabs md-sync-route :md-active-tab="activeTab" id="mo-accent" style="width: 100%;max-width:100vw" @md-changed="changedTab" class="md-primary">
              <md-tab id="tab-active" md-label="Inquiries">
                <dashboard-requests ref="dashRequestsRef"
                  :viewRequest="viewRequest"
                  :requests="inquiryRequests"
                  :dismissRequest="dismissRequest">
                </dashboard-requests>
              </md-tab>

              <md-tab id="tab-requests" md-label="Requests">
                <dashboard-requests ref="dashRequestsRef"
                  :viewRequest="viewRequest"
                  :requests="preBookingRequests"
                  :dismissRequest="dismissRequest">
                </dashboard-requests>
              </md-tab>

              <md-tab id="tab-archived" md-label="Bookings">
                <dashboard-requests ref="dashRequestsRef"
                  :viewRequest="viewRequest"
                  :requests="bookingRequests"
                  :dismissRequest="dismissRequest">
                </dashboard-requests>
              </md-tab>
            </md-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import DashboardRequests from '../../components/dashboard/dashRequests.vue';
  import DashboardDrawer from '../../components/dashboard/dashDrawer.vue';
  import {
    getRequest,
    upsertRequest
  }from '../../requestRepository.js'
  import { getCurrentFirebaseUser } from "@/platform/auth/services/authService.js";

  export default {
    components: {
      'dashboard-requests':DashboardRequests,
      'dashboard-drawer':DashboardDrawer
    },
    data() {
      return {
        reloadingDasboardItems: false,
        loadingDasboardItems: false,
        activeTab:'',
      };
    },
    computed: {
      placeholder() {
        return require('../../assets/placeholder.png')
      },
      refreshIcon(){
        return require('../../assets/refresh.svg')
      },
      loaderRolling(){
        return required('../../assets/loader-rolling.svg')
      },
      noRequests(){
        return !(this.$store.getters.dashRequests && this.$store.getters.dashRequests.length > 0)
      },
      dashRequests(){
        return this.$store.getters.dashRequests
      },
      dashRequestIds(){
        return this.$store.getters.dashRequestIds
      },
      bookingRequests(){
        return this.$store.getters.dashRequestsBookings
      },
      inquiryRequests(){
        return this.$store.getters.dashRequestsInquiries
      },
      preBookingRequests(){
        return this.$store.getters.dashRequestsPreBookings
      }
    },
    created() {
      if(!this.dashRequests || this.dashRequests.length <= 0) { //download requests if nothin in store
        this.getRequestsFromServer().then(response => {
          this.setRequestsToStore(response)
        })
      }else this.checkForRequestUpdates() //check updates on each
    },
    updated() {
    },
    methods: {
      changedTab(tabId){
      },
      checkForRequestUpdates(){
        this.reloadingDasboardItems = true

        this.getRequestIds().then(response => {
          if(response){

            // ADD NEW REQUESTS
            for(var i = 0; i<response.requestIds.length; i++){
              var requestId = response.requestIds[i]._id
              if(this.dashRequestIds[requestId] != 1){
                getRequest(requestId).then(res => {
                  if(res) this.addRequestToStore(res)
                })
              }
            }

            // REMOVE NON EXISTING REQUESTS
            for (var reqId in this.dashRequestIds) {
              var removeMe=true
              for(var i = 0; i<response.requestIds.length; i++){
                if(response.requestIds[i]._id == reqId){
                  removeMe=false
                  break;
                }
              }
              if(removeMe) this.removeRequest(reqId);
            }
            this.setRequestIdsToStore(response.requestIds)
            this.reloadingDasboardItems = false
          }
        })
      },
      reloadRequests(){
        this.$store.commit("RESET_REQUESTS_STATE")
        this.getRequestsFromServer()
      },
      getRequestsFromServer(){
        return new Promise((resolve, reject) => {
          this.reloadingDasboardItems = true
          this.loadingDasboardItems = true

          var user = getCurrentFirebaseUser()
          this.requests = []
          if(user && !user.isAnonymous) {
            var useruid = user.uid
            return this.getRequestIds().then(response => {
              if(!response) this.notifyError("Something is not right", "cannot get requests")
              else{
                this.setRequestIdsToStore(response.requestIds)
                var allPromises=[]
                for(var i = 0; i<response.nrOfRequests; i++){
                  (function (source, i, response) {
                    var requestId = response.requestIds[i]._id
                    source.addRequestToStore({"loading":true, "id": requestId})
                    var promise = getRequest(requestId).then(res => {
                      if(res) source.replaceTempRequestInStore(res)
                      return res
                    })
                    allPromises.push(promise)
                  })(this, i, response);
                }
              }
              this.reloadingDasboardItems = false
              this.loadingDasboardItems = false
            })
          }
        })
      },
      removeRequest(requestId){
        this.$store.dispatch('removeRequest', requestId);
      },
      setRequestIdsToStore(requestIds){
        this.$store.commit("setDashRequestIds", requestIds)
      },
      setRequestsToStore(requests){
        this.$store.commit("setDashRequests", requests)
      },
      replaceTempRequestInStore(request){
        this.$store.commit("replaceDashRequest", request)
      },
      addRequestToStore(request){
        this.$store.commit("addNewDashRequest", request)
      },
      getRequestIds(){
        return getOwnerRequestIds()
      },
      orderRequests(requests){
        if(requests){
          function compare(a, b) {
            const rA =a.createdAt
            const rB =b.createdAt

            let comparison = 0;
            if (rA < rB) {
              comparison = 1;
            } else if (rA > rB) {
              comparison = -1;
            }
            return comparison;
          }
          return requests.sort(compare)
        }
      },
      dismissRequest(request){
        //dimiss
        this.removeRequest(request.id)
        request.status="dismissed"
        upsertRequest(request).catch(err => {this.notifyError("Request update failed")})
      },
      isPresentInArray(ar, findMe){
        if(!ar) return false
        var len = ar.length;
        var i = 0;
        for (; i < len; ) {
          if (ar[i] == findMe) return true
        }
        return false
      },
      viewRequest(request){
      },
      notifyError(title, msg){
        this.$notify({
          title: title,
          message: msg
        })
      }
    }
  }

</script>
<style scoped>
  @import '../../assets/styles/dashboard.css';
  @import '../../assets/styles/global.css';
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Requests.vue